import script from "./buildOrder.vue?vue&type=script&lang=ts&setup=true"
export * from "./buildOrder.vue?vue&type=script&lang=ts&setup=true"

import "./buildOrder.vue?vue&type=style&index=0&id=13daf131&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13daf131"]])

export default __exports__